import teachAssistantTopDetail from "./teachAssistantTopDetail"; // 顶部详情
import teachAssistantDataBillBoard from "./teachAssistantDataBillBoard"; // 数据看板
import classPhoto from "./classPhoto"; //班级照片

export default [teachAssistantTopDetail, teachAssistantDataBillBoard, classPhoto];
